import { AlertTriangle, Inbox, RefreshCw } from 'lucide-react';

const DEFAULT_SKELETON_COUNT = 4;

export function LoadingState({
  variant = 'panel',
  count = DEFAULT_SKELETON_COUNT,
  label = 'Загружаем данные…',
  className = ''
}) {
  const rows = Array.from({ length: Math.max(1, count) }, (_, index) => index);

  return (
    <div className={`async-loading async-loading-${variant} ${className}`.trim()} role="status" aria-live="polite">
      <span className="async-state-sr">{label}</span>
      {rows.map((index) => (
        <div className="async-skeleton-item" key={index} aria-hidden="true">
          <span className="async-skeleton-media" />
          <span className="async-skeleton-copy">
            <i />
            <i />
            <i />
          </span>
          <span className="async-skeleton-action" />
        </div>
      ))}
    </div>
  );
}

export function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  icon: Icon = Inbox,
  compact = false,
  className = ''
}) {
  return (
    <div className={`async-state async-state-empty ${compact ? 'is-compact' : ''} ${className}`.trim()}>
      <span className="async-state-icon" aria-hidden="true">
        <Icon size={compact ? 20 : 26} />
      </span>
      <div className="async-state-copy">
        <strong>{title}</strong>
        {description ? <p>{description}</p> : null}
      </div>
      {actionLabel && onAction ? (
        <button type="button" className="async-state-action" onClick={onAction}>
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}

export function ErrorState({
  title = 'Не удалось загрузить данные',
  message,
  onRetry,
  retryLabel = 'Повторить',
  compact = false,
  className = ''
}) {
  return (
    <div
      className={`async-state async-state-error ${compact ? 'is-compact' : ''} ${className}`.trim()}
      role="alert"
    >
      <span className="async-state-icon" aria-hidden="true">
        <AlertTriangle size={compact ? 20 : 26} />
      </span>
      <div className="async-state-copy">
        <strong>{title}</strong>
        {message ? <p>{message}</p> : null}
      </div>
      {onRetry ? (
        <button type="button" className="async-state-action" onClick={onRetry}>
          <RefreshCw size={16} />
          {retryLabel}
        </button>
      ) : null}
    </div>
  );
}

export function InlineNotice({ tone = 'info', children, className = '' }) {
  if (!children) return null;
  const isError = tone === 'error';

  return (
    <div
      className={`async-inline-notice is-${tone} ${className}`.trim()}
      role={isError ? 'alert' : 'status'}
      aria-live={isError ? 'assertive' : 'polite'}
    >
      {children}
    </div>
  );
}
